import { post, get, ajax } from "jquery";
import fileDownload from 'js-file-download';
import moment, { isMoment } from "moment";
import * as CONST from './const';

class Utils {
    static getTranslateValue(reference, key) {
        if (reference == null || !reference.state.loadSuccess) {
            return "Loading...";
        }
        return reference.getValue(key);
    }

    static isNullOrEmpty(str) {
        return (!str || 0 === str.length) || (!str || /^\s*$/.test(str));
    }

    static IsFileImage(file) {
        const validImageTypes = ['image/gif', 'image/jpg', 'image/jpeg', 'image/png'];
        return file && ($.inArray(file['type'], validImageTypes) !== -1)
    }

    static csvFileDownload(url, list) {
        let fileName = moment().format(CONST.CSVDateFormat);
        post({ url: url, data: { rows: JSON.stringify(list) } }, response => {
            fileDownload("\uFEFF" + response, fileName + ".csv", 'text/csv');
        });
    }

    /** Date values to send to server. */
    static getValidDate(date) {
        if (null != date) {
            if (date instanceof String || date instanceof Date) {
                return moment(date).format(CONST.DateFormat)
            } else if (isMoment(date)) {
                return date.format(CONST.DateFormat)
            }
        }
        return null;
    }

    /** Convert date values from server to a valid JS date. */
    static convertToDate(date) {
        try {
            if (Utils.isNullOrEmpty(date)) {
                return null;
            } else {
                let validDate = new Date(moment(date));
                return validDate;
            }
        } catch (e) {
            return null;
        }
    }

    static getZaikoYm(date) {
        if (null != date) {
            let zaikoYm = null;
            try {
                zaikoYm = moment(date).format(CONST.ZAIKOYMFormat);
            } catch (e) { }
            return zaikoYm;
        }
        return null;
    }

    static updateTextTitle1(text, textTitle) {
        let newText = text.replace('販促品', textTitle);
        newText = newText.replace('書式', textTitle);
        return newText;
    }

    static isExceedingUpperLimit(limitDt, limitFlg, iraiQt, hachuMaxQt, limitCoefficient) {
        try {
            let ldate = moment(limitDt).format(CONST.DateFormat);
            let tdate = Utils.getValidDate(new Date());
            if (((null == ldate ? false : moment(ldate).isSameOrBefore(tdate)) || limitFlg != true)
                && (iraiQt > (hachuMaxQt * limitCoefficient))) {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    }

    static redirectToLogin() {
        window.location.href = window.domainDir + "Account/Login";
    }
}
export default Utils;


// WEBPACK FOOTER //
// ./helpers/utils.jsx